import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginModel } from '../models/login.model';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url = environment.urlApi + '/security';

  private session: any;

  // 👇 estado reactivo
  private authState = new BehaviorSubject<boolean>(this.autenticado());
  authState$ = this.authState.asObservable();

  constructor(private http: HttpClient) {}

  logIn(login: LoginModel) {
    return this.http.post(`${this.url}/login`, login).pipe(
      map((resp: any) => {
        this.guardarToken(resp);
        this.authState.next(true); // 👈 notifica login
        return resp;
      })
    );
  }

  logOut() {
    this.session = JSON.parse(localStorage.getItem('session') || '{}');
    return this.http.post(`${this.url}/logout`, this.session).pipe(
      map((resp) => {
        localStorage.removeItem('session');
        sessionStorage.removeItem('filterAdmin');
        this.authState.next(false); // 👈 notifica logout
        return resp;
      })
    );
  }

  private guardarToken(session: any) {
    session.admin = true;
    localStorage.setItem('session', JSON.stringify(session));
    this.session = session;
  }

  leerToken() {
    if (localStorage.getItem('session')) {
      this.session = JSON.parse(localStorage.getItem('session')!);
    } else {
      this.session = null;
    }
  }

  autenticado(): boolean {
    this.session = localStorage.getItem('session');
    if (this.session != null) {
      const timeNow = new Date().getTime();
      const tokenExp = new Date(JSON.parse(this.session).fechaexpiracion).getTime();
      if (tokenExp <= timeNow) {
        localStorage.removeItem('session');
        return false;
      }
      return true;
    }
    return false;
  }
}
